import BaseModel from '../core/BaseModel';

export default class VoucherCustomerModel extends BaseModel {

    constructor() {
        super({
                name: "voucher_customer",
                tableName: 'voucher_customer',
                label: "Voucher Customer",
                display_key: 'voucher_id'  // Hiển thị voucher_id trong bảng
            },
            {
                stt: {
                    name: "stt",
                    label: "No.",
                    type: "Computed",
                    computed: (data, index) => {
                        data.stt = index + 1;
                    },
                },
                id: {
                    name: 'id',
                    type: "Uuid",
                    label: 'ID',
                    primaryKey: true,
                    display: false
                },
                
                voucher_id: {
                    name: 'voucher_id',
                    type: "Uuid",
                    label: 'Voucher ID',
                    width: 20,
                    class: 'left',
                    display: false
                },
                uid: {
                    name: 'uid',
                    type: "Uuid",
                    label: 'User ID',
                    
                    class: 'left',
                    filter: { type: 'input', match: 'contains' },
                    display: false
                },
                fullname: {
                    name: 'fullname',
                    label: 'User',
                    type: "Computed",
                    computed: (data) => {
                        data.fullname = '';
                    },
                    width: 20,
                    class: 'left',
                },
                email: {
                    name: 'email',
                    label: 'Email',
                    type: "Computed",
                    computed: (data) => {
                        data.email = '';
                    },
                    width: 8,
                    class: 'left',
                },
                amount: {
                    name: 'amount',
                    label: 'Amount',
                    type: "Computed",
                    computed: (data) => {
                        data.amount = '';
                    },
                    class: 'left',
                    width: 15,
                },
                expires: {
                    name: 'expires',
                    label: 'Expires On',
                    type: "Computed",
                    computed: (data) => {
                        data.expires = '';
                    },
                    width: 8,
                    class: 'left',
                },
               
                order_id: {
                    name: 'order_id',
                    type: "Uuid",
                    label: 'Order ID',
                    width: 20,
                    class: 'left',
                    filter: { type: 'input', match: 'contains' },
                    display: false
                },
                created_at: {
                    name: 'created_at',
                    type: "Custom",
                    label: 'Created Date',
                    class: 'left',
                    width: 8,
                },
                status: {
                    name: 'status',
                    type: "String",
                    label: 'Status',
                    width: 8,
                    class: 'left',
                    filter: { type: 'input', match: 'contains' },
                },
             
                updated_at: {
                    name: 'updated_at',
                    type: "Datetime",
                    label: 'Updated At',
                    class: 'center',
                    filter: { type: 'DateRange', match: 'equals' },
                    display: false
                },
                created_by: {
                    name: 'created_by',
                    type: "Uuid",
                    label: 'Created By',
                    width: 8,
                    class: 'left',
                },
                updated_by: {
                    name: 'updated_by',
                    type: "Uuid",
                    label: 'Updated By',
                    width: 8,
                    class: 'left',
                },
              
                active: {
                    name: "active",
                    label: "Active",
                    type: "Selection",
                    custom: 'SelectionText',
                    options: [
                        { value: 'true', label: 'Yes', style: 'color:  #000000;' },
                        { value: 'false', label: 'No', style: 'color:  #000000;' }
                    ],
                    filter: {
                        type: 'select',
                        optionLabel: 'label',
                        optionKey: 'value',
                        match: 'equals'
                    },
                    class: "center",
                    width: 8,
                    display: false
                },
                deleted: {
                    name: "deleted",
                    type: "Boolean",
                    label: "Deleted",
                    display: false
                },
                 detail_get: {
                    refs:  ' users { id fullname email }  voucher { id valid_end type_discount amount valid_end } obj_updated_by { id fullname } obj_created_by { id fullname }',
                    display: false
                },
            })
    }
}
